import { useSelector } from 'react-redux';
import { usePrefs } from 'wsm-common-data';
import {
	selectIsGridLayout,
	getShouldShowCompareOverImage
} from '../utilities/layout';

/**
 * Centralises the compare-over-image gate so every container that
 * renders CompareButton shares the same logic.
 *
 * @returns {boolean} Whether the compare icon should overlay the vehicle image.
 */
export const useCompareOverImage = () => {
	const { enableCompare, enableCompareOverImage } = usePrefs();
	const isGridLayout = useSelector((state) => selectIsGridLayout(state));
	const { isSmallScreen } = useSelector((state) => state.layout);

	return getShouldShowCompareOverImage(
		enableCompare,
		enableCompareOverImage,
		isGridLayout,
		isSmallScreen
	);
};
